/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
/* eslint-disable no-await-in-loop */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useMemo, useContext, useEffect } from "react";
import JoditEditor from "jodit-react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ClearIcon from "@mui/icons-material/Clear";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Button from "../../../components/common/Button";
import Style from "./styles";
import Loader from "../../../components/common/Loader/Loader";
import Emailer from "../../../services/api/emailer";
import InputField from "../../../components/common/new/InputField/InputField";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../contants";
import Dropdown from "../../../components/common/new/Dropdown/Dropdown";
import UploadFile from "../Components/UploadFile";
import { ROUTES } from "../../../utils/constants";

const TEMPLATE_OPTIONS = [
  {
    key: "Manual Template",
    value: "MANUAL_TEMPLATE",
  },
  {
    key: "Upload Template",
    value: "UPLOAD_TEMPLATE",
  },
];

function EmailUpdate({ placeholder }) {
  const TITLE = "Update Email Template - BSG";
  const editor = useRef(null);
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [attachmentsData, setAttachmentsData] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const fileInputRef = useRef(null);
  const attachmentInputRef = useRef(null);
  const [templateName, setTemplateName] = useState("");
  const [subject, setSubject] = useState("");
  const [filename, setFilename] = useState("");
  const [zipFile, setZipFile] = useState(null);
  const toast = useContext(ToastAlertContext);
  const navigate = useNavigate();
  const [selectedTemplateType, setSelectedTemplateType] =
    useState("MANUAL_TEMPLATE");

  const { id } = useParams();
  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: placeholder || "Start typing...",
      height: "500px",
    }),
    [placeholder]
  );
  const validateEmailer = () => {
    if (!subject.trim() && !templateName.trim()) {
      toast.show("Subject and Template Name can't be empty", AlertStatus.ERROR);
      return false;
    }

    if (!subject.trim()) {
      toast.show("Subject can't be empty", AlertStatus.ERROR);
      return false;
    }

    if (!templateName.trim()) {
      toast.show("Template Name can't be empty", AlertStatus.ERROR);
      return false;
    }

    return true;
  };
  const handleButtonClick = async () => {
    try {
      setIsLoading(true);
      if (!validateEmailer()) {
        setIsLoading(false);
        return;
      }

      if (zipFile) {
        const formData = new FormData();
        formData.append("templateName", templateName);
        formData.append("subject", subject);
        formData.append(
          "file",
          new Blob([zipFile], { type: "text/html" }),
          filename
        );
        const response = await Emailer.createEmailerTemplate({
          data: formData,
        });
        if (response.code === 200) {
          toast.show("Template Created Successfully", AlertStatus.SUCCESS);
          navigate(ROUTES.EMAILER_TEMPLATES.path);
        }
      } else {
        const formData = new FormData();
        formData.append("templateName", templateName);
        formData.append("subject", subject);
        formData.append("body", content);
        attachments.forEach((attachmentId) => {
          formData.append("fileIds[]", attachmentId);
        });
        const response = await Emailer.updateEmailerTemplate({
          data: formData,
          templateId: id,
        });
        if (response.code === 200) {
          toast.show("Template Updated Successfully", AlertStatus.SUCCESS);
          navigate(ROUTES.EMAILER_TEMPLATES.path);
        }
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    } finally {
      setIsLoading(false);
    }
  };
  const handleTemplateName = (event) => {
    setTemplateName(event.target.value);
  };
  const handleSubject = (event) => {
    setSubject(event.target.value);
  };
  const handleDeleteTemplateClick = () => {
    setContent("");
    setAttachments([]);
    setAttachmentsData([]);
    setTemplateName("");
    setSubject("");
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setFilename(file?.name);
    if (file) {
      const reader = new FileReader();
      reader.onload = (fileLoadEvent) => {
        const arrayBuffer = fileLoadEvent.target.result;
        setZipFile(arrayBuffer);
      };

      reader.readAsArrayBuffer(file);
    }
  };
  const handleAttachments = async (event) => {
    const allowedFileTypes = [
      "application/msword",
      "application/vnd.ms-excel",
      "application/pdf",
      "text/plain",
      "text/csv",
      "application/xml",
      "text/xml",
      "image/png",
      "image/webp",
      "image/jpeg",
      "application/zip",
      "application/gzip",
      "application/x-zip-compressed",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/x-7z-compressed",
      "application/vnd.google-apps.document",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.google-apps.kix",
      "application/vnd.google-apps.form",
      "application/vnd.google-apps.presentation",
      "application/vnd.google-apps.spreadsheet",
    ];

    const { files } = event.target;
    if (files.length === 0) {
      toast.show("No file selected.", AlertStatus.ERROR);
      return;
    }

    for (const file of files) {
      if (!allowedFileTypes.includes(file.type)) {
        toast.show("Selected file format is not supported", AlertStatus.ERROR);
        continue;
      }

      try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await Emailer.uploadEmailAttachments({
          data: formData,
        });
        if (response.code === 200) {
          const { data } = response;
          toast.show("File Attached Successfully", AlertStatus.SUCCESS);
          // setAttachmentsData((prevAttachmentsData) => [
          //   ...prevAttachmentsData,
          //   data,
          // ]);
          // setAttachments((prevAttachments) => [...prevAttachments, data.id]);
          setAttachmentsData((prevAttachmentsData) => {
            return Array.isArray(prevAttachmentsData)
              ? [...prevAttachmentsData, data]
              : [data];
          });

          setAttachments((prevAttachments) => {
            return Array.isArray(prevAttachments)
              ? [...prevAttachments, data.id]
              : [data.id];
          });
        }
      } catch (error) {
        toast.show(
          "Error uploading file. Please try again.",
          AlertStatus.ERROR
        );
      }
    }
  };
  const handleRemoveAttachment = (attachmentIndex, attachmentId) => {
    setAttachmentsData((prevAttachments) =>
      prevAttachments.filter((_, index) => index !== attachmentIndex)
    );
    setAttachments((prevAttachments) =>
      prevAttachments.filter((ide) => ide !== attachmentId)
    );
  };
  const handleAttachmentClick = (attachment) => {
    if (attachment?.signedS3Url !== null) {
      window.open(attachment?.signedS3Url, "_blank");
    }
  };

  const handleButtonChoose = () => {
    fileInputRef.current.click();
  };
  const handleButtonAttach = () => {
    attachmentInputRef.current.click();
  };
  const handleTemplateChange = (event) => {
    setSelectedTemplateType(event.target.value);
  };
  const getHTMLTemplate = async () => {
    try {
      setIsLoading(true);
      const response = await Emailer.getHTMLTemplate(id);
      console.log(response);
      //   setHtmlData(response);
      setContent(response?.data?.body);
      setTemplateName(response?.data?.templateName);
      setSubject(response?.data?.subject);
      setAttachmentsData(response?.data?.attachments);
      const attachmentIds = response?.data?.attachments.map(
        (attachment) => attachment?.id
      );
      setAttachments(attachmentIds);
    } catch (error) {
      // toast.show(error.message, AlertStatus.ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getHTMLTemplate();
  }, []);
  // console.log("line 248", attachments);
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div style={Style.div}>
        <Box
          style={{
            display: "flex",
            gap: "20px",
            justtifyContent: "space-between",
          }}
        >
          <Box width="33%">
            <InputField
              label="Template Name"
              value={templateName}
              onChange={handleTemplateName}
              required
            />
          </Box>
          <Box width="33%">
            <InputField
              label="Subject"
              value={subject}
              onChange={handleSubject}
              required
            />
          </Box>
          <Box width="33%">
            <Dropdown
              value={selectedTemplateType}
              options={TEMPLATE_OPTIONS}
              label="Select Template Mode"
              onChange={handleTemplateChange}
              disabled
            />
          </Box>
        </Box>
        {selectedTemplateType === TEMPLATE_OPTIONS[0].value ? (
          <div>
            <Box style={Style.tableTitle}>Manual Entry Template</Box>
            <JoditEditor
              ref={editor}
              value={content}
              config={config}
              tabIndex={1}
              onBlur={(newContent) => setContent(newContent)}
            />
            <div onClick={handleButtonAttach} style={Style.attachments}>
              <AttachFileIcon sx={{ cursor: "pointer" }} />
              <p style={{ cursor: "pointer" }}>Attachments</p>
            </div>
            <input
              type="file"
              onChange={handleAttachments}
              ref={attachmentInputRef}
              style={{ display: "none" }}
              multiple
            />
          </div>
        ) : (
          <>
            <Box style={Style.tableTitle}>Upload Template</Box>
            <UploadFile
              handleFileUpload={handleFileUpload}
              handleButtonChoose={handleButtonChoose}
              fileInputRef={fileInputRef}
              filename={filename}
            />
            <Box style={Style.noteText}>
              Note<span style={Style.redAsterisk}>*</span>: Size of the upload
              file should not exceed 5MB
            </Box>
          </>
        )}
      </div>
      {attachmentsData?.length > 0 && (
        <div style={Style.attachmentsLists}>
          <ul>
            {attachmentsData?.map((attachment, index) => (
              <div style={{ display: "flex", gap: "5px" }}>
                <li
                  style={Style.attachmentsListsItems}
                  onClick={() => handleAttachmentClick(attachment)}
                >
                  {attachment?.originalFileName}
                  {/* <ClearIcon
                  onClick={() => handleRemoveAttachment(index, attachment?.id)}
                  style={{ cursor: "pointer" }}
                /> */}
                </li>
                <ClearIcon
                  onClick={() => handleRemoveAttachment(index, attachment?.id)}
                  style={{ cursor: "pointer", color: "#15c" }}
                />
              </div>
            ))}
          </ul>
        </div>
      )}
      <nav style={Style.nav}>
        <Button
          variant="contained"
          onClick={handleButtonClick}
          label="Update"
        />
        {selectedTemplateType === TEMPLATE_OPTIONS[0].value ? (
          <Button
            variant="contained"
            onClick={handleDeleteTemplateClick}
            label="Clear"
          />
        ) : (
          <Button
            variant="contained"
            onClick={() => setSelectedTemplateType(TEMPLATE_OPTIONS[0].value)}
            label="Cancel"
          />
        )}
      </nav>
      {isLoading && <Loader />}
    </>
  );
}
export default EmailUpdate;
